module.exports = __webpack_public_path__ + "static/media/plane(2).e4dbadad.PNG";